import { useTranslations } from 'next-intl';
import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure } from '@headless-workspace/core-domain';
import { getProductDeliveryInfoServerAction, ProductDeliveryInfoValue } from '../../../server';
import { RevalidationStrategy, useSafeSWR } from '../hooks';

const PRODUCT_DELIVERY_INFO_DEFAULT_ERROR = 'PRODUCT_DELIVERY_INFORMATION_ERROR';

export const useProductDeliveryInfo = (sku?: string): AsyncData<ProductDeliveryInfoValue> => {
    const t = useTranslations('Common.delivery.error');

    const { data, isLoading, error } = useSafeSWR(
        sku ? [CacheKeys.ProductDeliveryInfo, sku] : null,
        ServerActionName.getProductDeliveryInfo,
        () => getProductDeliveryInfoServerAction(sku),
        RevalidationStrategy.WarmDataPolicy,
    );

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure(
                    PRODUCT_DELIVERY_INFO_DEFAULT_ERROR,
                    error instanceof Error ? error.message : t('default'),
                ),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: data };
};
